import React, { Fragment, useEffect, useState, useMemo } from "react";
import { observer } from "mobx-react-lite";
import { useQuery, gql, useMutation } from "@apollo/client";
import iteminfo from "../packagedata/data";
import { Card } from "../card";
import {
  LOAD_PACKAGES,
  PROMOTION_PACKAGES,
  LOAD_PACKAGES_WISHLIST,
  LOAD_PROFILE_INFO,
  LOAD_HIGHLIGHTED_PACKAGES,
} from "../../GraphQL/Queries";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { PACKAGE_WISHLIST_MUTATION } from "../../GraphQL/Mutations";
import { useNavigate, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { GrNext, GrPrevious } from "react-icons/gr";
import {
  leftVariants2,
  staggerPackagesVariants,
} from "../../constants/variants";
import { debounce, findBestPackagePrice } from "utils/helpers";
import SearchStore from "stores/searchStore";
import { errorToast, successToast, warningToast } from "components/toast/toast";
import { Button } from "components/buttons";
import Pagination from "components/pagination";
import Loader from "components/loader/Loader";
import { images } from "constants";

export const Packages = () => {
  const [packages, setPackages] = useState([]);
  const { error, loading, data } = useQuery(LOAD_PACKAGES, {
    variables: {
      page: 1,
      limit: 6,
    },
  });
  useEffect(() => {
    if (data) {
      setPackages(data.getPackages.slice(0, 6));
    }
  }, [data]);

  return (
    <div className="flex flex-wrap m-auto gap-8 justify-center mt-8">
      {packages.map((item, index) => {
        let firstIndex;
        item?.room_rates?.map((item, index) => {
          if (item.variant_week < 2 && item.room_type === "DOUBLE") {
            firstIndex = index;
          }
        });
        return (
          <>
            {firstIndex !== undefined && (
              <Card
                className=""
                price={item?.room_rates[firstIndex]?.rate}
                image={item?.images[0]}
                startDate={item?.departure_date}
                endDate={item?.return_date}
                tripPackage={item.name}
                flag={item.country}
                available="true"
                key={item.id}
                details={`/packages/${item.id}`}
              />
            )}
          </>
        );
      })}
    </div>
  );
};

export const LandingPagePackages = ({ country }) => {
  const { data: highlightedPackages, loading } = useQuery(
    LOAD_HIGHLIGHTED_PACKAGES,
    {
      variables: {},
    },
  );

  return (
    <Fragment>
      {loading && <Loader />}
      <motion.div
        initial="startAnimation"
        variants={staggerPackagesVariants}
        whileInView="endAnimation"
        viewport={{ once: true }}
        className="md:grid xs:flex md:overflow-hidden xs:overflow-x-scroll md:grid-cols-2 lg:grid-cols-4 md:gap-x-[13px] md:gap-y-8 md:justify-center"
      >
        <Fragment>
          {highlightedPackages?.getHighlightedPackages?.packages
            ?.slice(0, 4)
            ?.map((item) => {
              return (
                <motion.div
                  whileInView="endAnimation"
                  className="lg:min-w-[unset] min-w-[309px]"
                  viewport={{ once: true }}
                  variants={leftVariants2}
                  key={item?.id}
                >
                  <Card
                    landing
                    country={country}
                    price={findBestPackagePrice(item?.package?.room_rates)}
                    image={item?.package?.images[0]}
                    startDate={item?.package?.departure_date}
                    endDate={item?.package?.return_date}
                    tripPackage={item?.package.name}
                    flag={item?.package?.country}
                    available="true"
                    key={item?.id}
                    details={`/packages/${item?.package?.id}`}
                  />
                </motion.div>
              );
            })}
        </Fragment>
      </motion.div>
    </Fragment>
  );
};

export const UserPackages = observer(({ searchTrip, type, search }) => {
  const { searchLoading, setCountriesFilter, refreshSearch } = SearchStore;
  const [packages, setPackages] = useState([]);
  const [total, setTotal] = useState(0);
  const navigate = useNavigate();

  const [page, setPage] = useState(1);
  const [limit] = useState(12);

  const [budget, setBudget] = useState({
    min: null,
    max: null,
  });

  const [date, setDate] = useState({
    min: null,
    max: null,
  });

  const loadPackages = useQuery(LOAD_PACKAGES, {
    variables: {
      page: page,
      limit: limit,
      destination: searchTrip?.destination,
      number_travellers: searchTrip?.total_travellers,
      departure_date: date.min,
      return_date: date.max,
      min_budget: parseInt(budget.min),
      max_budget: parseInt(budget.max),
      categories: searchTrip.categories,
      account_type: "DOLLAR_ACCOUNT",
      visibility: "PUBLIC",
      search: search,
    },
  });

  console.log({ loadPackages });

  const [addFavourite] = useMutation(PACKAGE_WISHLIST_MUTATION);

  const handleWishlist = (item) => {
    addFavourite({
      variables: {
        package: item.id,
      },
    })
      .then((response) => {
        // this means error was gotten, check the register query for reference
        if (response.data.addFavourite.__typename === "BadRequest") {
          warningToast("Warning", response.data.addFavourite.message);
        }
        if (response.data.addFavourite.__typename === "AddFavouriteSuccess") {
          response.data.addFavourite.favourite
            ? successToast("Success", "Package added to wishlist")
            : successToast("Success", "Package removed from wishlist");
        }
      })

      .catch((error) => {
        errorToast("Error", error ? error?.message : "An error occured");
      });

    const newPackagesData = packages.map((e) => {
      if (e.id === item.id) {
        const updatedItem = {
          ...e,
          isFavorite: !e.isFavorite,
        };
        return updatedItem;
      }
      return e;
    });
    setPackages(newPackagesData);
  };

  useEffect(() => {
    if (loadPackages.data) {
      setPackages(loadPackages.data.getPackages.packages);
      setCountriesFilter(loadPackages.data.getPackages.destinations);
      setTotal(loadPackages.data.getPackages.total);
    }
  }, [
    budget,
    date,
    loadPackages.data,
    searchTrip.destination,
    searchTrip.total_travellers,
    searchTrip.categories,
    setCountriesFilter,
  ]);

  useEffect(
    debounce(() => {
      if (loadPackages.data) {
        if (searchTrip.budget.minValue && searchTrip.budget.maxValue) {
          setBudget({
            min: searchTrip.budget.minValue,
            max: searchTrip.budget.maxValue,
          });
        } else if (!searchTrip.budget.minValue && !searchTrip.budget.maxValue) {
          setBudget({
            min: searchTrip.budget.minValue,
            max: searchTrip.budget.maxValue,
          });
        }

        if (searchTrip.departure && searchTrip.return) {
          // filtering by date range

          setDate({
            min: searchTrip.departure,
            max: searchTrip.return,
          });
        } else if (!searchTrip.departure && !searchTrip.return) {
          setDate({
            min: searchTrip.departure,
            max: searchTrip.return,
          });
        }
      }
      //==================================================================
    }, 2000),

    [searchLoading, searchTrip.budget, searchTrip.departure, searchTrip.return],
  );

  const [packagesWishlistData, setPackagesWishlistData] = useState([]);
  const wishList = useQuery(LOAD_PACKAGES_WISHLIST);

  useEffect(() => {
    if (wishList.data) {
      setPackagesWishlistData(wishList.data.me.user.favourites);
    }
  }, [wishList.data]);

  const idArray = [];
  packagesWishlistData?.map((item, index) => {
    if (item.package) {
      idArray.push(item.package.id);
    }
  });

  return (
    <Fragment>
      {loadPackages.loading && <Loader />}
      {!loadPackages.loading && packages?.length > 0 && (
        <div className="grid xs:grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-4 gap-y-8 justify-center">
          <Fragment>
            {packages.map((item, index) => {
              // let firstIndex;
              // item?.room_rates?.map((item, index) => {
              //   if (item.variant_week < 2 && item.room_type === "DOUBLE") {
              //     firstIndex = index;
              //   }
              // });

              const here = idArray?.includes(item.id) ? true : false;

              const check = () => {
                if (idArray?.includes(item.id)) {
                  return true;
                } else {
                  return false;
                }
              };

              return (
                <div className="mx-auto" key={item.id}>
                  <Card
                    className=""
                    price={findBestPackagePrice(item?.room_rates)}
                    image={
                      item?.images[
                        Math.floor(Math.random() * item?.images?.length)
                      ]
                    }
                    startDate={item?.departure_date}
                    endDate={item?.return_date}
                    tripPackage={item.name}
                    flag={item.country}
                    available="true"
                    handleWishlist={() => handleWishlist(item)}
                    details={`/packages/${item.id}`}
                    country={item.account_type}
                    inWishlist={here}
                  />
                </div>
              );
            })}
          </Fragment>
        </div>
      )}
      {!loadPackages.loading && loadPackages.data && packages?.length === 0 && (
        <div className="mx-auto flex flex-col space-y-4 justify-center w-[70%]">
          <div className="mb-[30px] flex flex-col justify-center items-center">
            <img
              alt=""
              className={`sm:w-[60%] md:w-[35%]`}
              src={images.emptyFilter}
            />
            <div className="text-[#093549] textc text-[24px] font-bold">
              Package filters Unavailable
            </div>
            <div className="mt-[4px] text-center text-[#5D6D8F] text-[16px]">
              Unfortunately, the filtered options are unavailable
            </div>

            <div
              className={`mt-[20px] flex md:flex-row flex-col gap-4 w-full `}
            >
              <Button
                text={"Explore other packages"}
                className="w-full px-3 border-[2px] border-blue-100"
                onClick={() => {
                  refreshSearch();
                }}
              />

              <Button
                text={"Create custom package"}
                className="w-full px-3"
                isBlue
                onClick={() => navigate("/plan-trip")}
              />
            </div>
          </div>
        </div>
      )}

      {packages?.length > 0 && (
        <div className="flex items-end w-full ">
          <div className="flex text-sm text-[#525866]">
            Page {page} of {Math.ceil(packages?.length / limit)}
          </div>

          <div className="flex-1">
            <Pagination
              pageCount={Math.ceil(total / limit)}
              onPageChange={(page) => {
                setPage(page);
              }}
              currentPage={page}
            />
          </div>
        </div>
      )}
    </Fragment>
  );
});

export const AllPackages = ({ id }) => {
  const [packages, setPackages] = useState([]);
  const [user, setUser] = useState([]);
  const [tablet, setTablet] = useState(false);

  const loadPackages = useQuery(LOAD_PACKAGES, {
    variables: {
      page: 1,
      limit: 4,
    },
  });
  const loadSingleUser = useQuery(LOAD_PROFILE_INFO);

  const [addFavourite, { loading, error }] = useMutation(
    PACKAGE_WISHLIST_MUTATION,
  );

  const handleWishlist = (item) => {
    addFavourite({
      variables: {
        package: item.id,
      },
    })
      .then((response) => {
        // this means error was gotten, check the register query for reference
        if (response.data.addFavourite.__typename === "BadRequest") {
          warningToast("Warning", response.data.addFavourite.message);
        }
        if (response.data.addFavourite.__typename === "AddFavouriteSuccess") {
          response.data.addFavourite.favourite
            ? successToast("Success", "Package added to wishlist")
            : successToast("Success", "Package removed from wishlist");
        }
      })
      .catch((error) => {
        errorToast("Error", error ? error?.message : "An error occured");
      });
    const newPackagesData = packages.map((e) => {
      if (e.id === item.id) {
        const updatedItem = {
          ...e,
          isFavorite: !e.isFavorite,
        };
        return updatedItem;
      }
      return e;
    });
    setPackages(newPackagesData);
  };
  useEffect(() => {
    if (loadPackages.data) {
      setPackages(loadPackages.data.getPackages.packages);
    }

    if (loadSingleUser.data) {
      setUser(loadSingleUser.data.me.user);
    }

    if (window.innerWidth > 900) {
      setTablet(false);
    } else {
      setTablet(true);
    }
  }, [loadPackages.data]);

  const [packagesWishlistData, setPackagesWishlistData] = useState([]);
  const wishList = useQuery(LOAD_PACKAGES_WISHLIST);

  useEffect(() => {
    if (wishList.data) {
      setPackagesWishlistData(wishList.data.me.user.favourites);
    }
  }, [wishList.data]);

  const idArray = [];

  packagesWishlistData?.map((item, index) => {
    if (item.package) {
      idArray.push(item.package.id);
    }
  });

  function check(sample) {
    if (idArray.includes(sample)) {
      return true;
    } else {
      return false;
    }
  }

  var settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    arrows: true,
    autoplaySpeed: 3000,
    speed: 1000,
    slidesToShow: 2,
    className: "slick-dots",
    slidesToScroll: 1,
    // fade: true,
    lazyLoad: "ondemand",
    swipe: true,
    nextArrow: <GrNext />,
    prevArrow: <GrPrevious />,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <Fragment>
      {loadPackages.loading && <Loader />}
      {!loadPackages.loading && packages.length > 0 && (
        <div>
          <div className="mdLg:grid xs:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-8 justify-center hidden ">
            <Fragment>
              {packages?.map((item, index) => {
                let firstIndex;
                item?.room_rates?.map((item, index) => {
                  if (item.variant_week < 2 && item.room_type === "DOUBLE") {
                    firstIndex = index;
                  }
                });

                return (
                  <Fragment key={item.id}>
                    {firstIndex !== undefined && (
                      <Card
                        className=""
                        price={findBestPackagePrice(item?.room_rates)}
                        image={
                          item?.images[
                            Math.floor(Math.random() * item?.images.length)
                          ]
                        }
                        startDate={item?.departure_date}
                        endDate={item?.return_date}
                        tripPackage={item?.name}
                        flag={item.country}
                        available="true"
                        handleWishlist={() => handleWishlist(item)}
                        isFavorite={item.favourites.includes(id)}
                        details={`/packages/${item.id}`}
                        inWishlist={check(item.id)}
                      />
                    )}
                  </Fragment>
                );
              })}
            </Fragment>
          </div>
          <div className="home-packages relative h-[400px] w-full mx-auto mdLg:hidden block">
            <Fragment>
              <Slider {...settings}>
                {packages?.map((item, index) => {
                  let firstIndex;
                  item?.room_rates?.map((item, index) => {
                    if (item.variant_week < 2 && item.room_type === "DOUBLE") {
                      firstIndex = index;
                    }
                  });

                  return (
                    <Fragment key={item.id}>
                      {firstIndex !== undefined && (
                        <Card
                          containerClass="w-[100%] xs:w-[90%] sm:w-[70%] mx-auto md:w-[90%]"
                          className=""
                          price={findBestPackagePrice(item?.room_rates)}
                          image={item?.images[0]}
                          startDate={item?.departure_date}
                          endDate={item?.return_date}
                          tripPackage={item.name}
                          flag={item.country}
                          available="true"
                          handleWishlist={() => handleWishlist(item)}
                          isFavorite={item.favourites.includes(id)}
                          details={`/packages/${item.id}`}
                          inWishlist={check(item.id)}
                        />
                      )}
                    </Fragment>
                  );
                })}
              </Slider>
            </Fragment>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export const OtherPackages = (type) => {
  const [packages, setPackages] = useState([]);

  const loadPackages = useQuery(LOAD_PACKAGES, {
    variables: {
      page: 1,
      limit: 6,
      account_type: type?.type,
    },
  });

  const [addFavourite] = useMutation(PACKAGE_WISHLIST_MUTATION);

  const { id } = useParams();
  const handleWishlist = (item) => {
    addFavourite({
      variables: {
        package: item.id,
      },
    })
      .then((response) => {
        if (response.data.addFavourite.__typename === "BadRequest") {
          warningToast("Warning", response.data.addFavourite.message);
        } else if (
          response.data.addFavourite.__typename === "AddFavouriteSuccess"
        ) {
          response.data.addFavourite.favourite
            ? successToast("Success", "Package added to wishlist")
            : successToast("Success", "Package removed from wishlist");
        }
      })
      .catch((error) => {
        errorToast("Error", error ? error?.message : "An error occured");
      });
    const newPackagesData = packages.map((e) => {
      if (e.id === item.id) {
        const updatedItem = {
          ...e,
          isFavorite: !e.isFavorite,
        };
        return updatedItem;
      }
      return e;
    });
    setPackages(newPackagesData);
  };
  useEffect(() => {
    if (loadPackages.data) {
      const filteredPackages = [];
      loadPackages.data?.getPackages?.packages?.forEach((element) => {
        if (element.id !== id) {
          filteredPackages.push(element);
        }
      });
      setPackages(filteredPackages);
    }
  }, [loadPackages.data]);

  const [packagesWishlistData, setPackagesWishlistData] = useState([]);
  const wishList = useQuery(LOAD_PACKAGES_WISHLIST);

  useEffect(() => {
    if (wishList.data) {
      setPackagesWishlistData(wishList.data.me.user.favourites);
    }
  }, [wishList.data]);

  const idArray = [];
  packagesWishlistData.map((item, index) => idArray.push(item.package.id));

  function check(sample) {
    if (idArray.includes(sample)) {
      return true;
    } else {
      return false;
    }
  }

  return (
    <Fragment>
      {loadPackages.loading && <Loader />}
      {!loadPackages.loading && (
        <div className="flex flex-row flex-wrap md:flex-col gap-x-4 gap-y-8 justify-center">
          <Fragment>
            {packages?.slice(0, 3)?.map((item) => {
              let firstIndex;
              item?.room_rates?.map((item, index) => {
                if (item.variant_week < 2 && item.room_type === "DOUBLE") {
                  firstIndex = index;
                }
              });
              return (
                <>
                  {firstIndex !== undefined && (
                    <Card
                      containerClass="w-full sm:w-[40%] md:w-[85%]   mx-0  md:mx-auto"
                      price={findBestPackagePrice(item?.room_rates)}
                      image={
                        item?.images[
                          Math.floor(Math.random() * item?.images?.length)
                        ]
                      }
                      startDate={item?.departure_date}
                      endDate={item?.return_date}
                      tripPackage={item.name}
                      flag={item.country}
                      available="true"
                      handleWishlist={() => handleWishlist(item)}
                      key={item.id}
                      country={item.account_type}
                      // isFavorite={item.favourites.includes(user_id)}
                      details={`/packages/${item.id}`}
                      inWishlist={check(item.id)}
                    />
                  )}
                </>
              );
            })}
          </Fragment>
        </div>
      )}
    </Fragment>
  );
};
